import { createAction } from 'redux-actions';
import { CALL_API } from 'middlewares/api';
import { POST_API } from 'middlewares/form';
import LGTM from 'lgtm';

export const OFFERS_PER_PAGE = 50;

export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_REQUEST_SUCCESS = 'PROFILE_REQUEST_SUCCESS';
export const PROFILE_REQUEST_FAILURE = 'PROFILE_REQUEST_FAILURE';
export const requestProfile = (pageNumber = 1) => (dispatch, getState) => {
  const { username } = getState().product.sellerInfo.seller;
  dispatch({
    [CALL_API]: {
      types: [PROFILE_REQUEST, PROFILE_REQUEST_SUCCESS, PROFILE_REQUEST_FAILURE],
      endpoint: `/webapi/profile/${username}/?page=${pageNumber}&entries=${OFFERS_PER_PAGE}`,
    },
  });
};

export const EDIT_SHORTURL = 'EDIT_SHORTURL';
export const editShortUrl =
  (identifier) => createAction(EDIT_SHORTURL)({ identifier });

export const CHANGE_IS_SHORTURL_EDITABLE = 'CHANGE_IS_SHORTURL_EDITABLE';
export const changeIsShortUrlEditable =
  (isEditing) => createAction(CHANGE_IS_SHORTURL_EDITABLE)({ isEditing });

export const RESET_SHORTURL = 'RESET_SHORTURL';
export const resetShortUrl =
  () => createAction(RESET_SHORTURL)();

const shortUrlValidator =
  LGTM.validator()
    .validates('identifier')
      .required('This field cannot be empty.')
    .build();

export const CHANGE_SHORTURL_REQUEST = 'CHANGE_SHORTURL_REQUEST';
export const CHANGE_SHORTURL_SUCCESS = 'CHANGE_SHORTURL_SUCCESS';
export const CHANGE_SHORTURL_FAILURE = 'CHANGE_SHORTURL_FAILURE';
export const changeShortUrl = () => (dispatch, getState) => {
  const { product } = getState();
  const { username } = product.sellerInfo.seller;
  const { slug } = product.offerInfo;
  const { shortUrlIdentifier } = product.shortUrlForm;
  dispatch({
    [POST_API]: {
      types: [CHANGE_SHORTURL_REQUEST, CHANGE_SHORTURL_SUCCESS, CHANGE_SHORTURL_FAILURE],
      endpoint: `/webapi/${username}/${slug}/shorturl/`,
      payload: {
        identifier: shortUrlIdentifier,
      },
      toValidate: { identifier: shortUrlIdentifier },
      validator: shortUrlValidator,
      failureActionErrors: ({ errors }) => errors,
    },
  });
};


import {
  initializePurchaseValidator,
  initializePurchaseToValidate,
  initializePurchasePayload,
  HANDLE_SUBMIT_INITIALIZE_PURCHASE_FAILURE,
} from '../../payments/actions/InitializePurchaseActions';

import {
  refinePurchaseValidator,
  refinePurchaseToValidate,
  refinePurchasePayload,
  HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE,
} from '../../payments/actions/RefinePurchaseActions';

import {
  handleAddToCart,
} from 'actions/CartActions';

const getAddToCartPayload = (store) => ({
  ...initializePurchasePayload({ store }),
  ...refinePurchasePayload({ store }),
});

export const handleValidateAddToCart = ({ slug, analytics = {} }) =>
  (dispatch, getState) => {
    const { payments: store } = getState();
    let isInitializePurchaseValid = true;
    let isRefinePurchaseValid = true;

    initializePurchaseValidator({ store }).validate(
      initializePurchaseToValidate({ store }), (err, result) => {
        if (!result.valid) {
          isInitializePurchaseValid = false;
          dispatch({
            type: HANDLE_SUBMIT_INITIALIZE_PURCHASE_FAILURE,
            errors: result.errors,
          });
        }

        refinePurchaseValidator({ store }).validate(
          refinePurchaseToValidate({ store }), (err, result) => {
            if (!result.valid) {
              isRefinePurchaseValid = false;
              return dispatch({
                type: HANDLE_SUBMIT_REFINE_PURCHASE_FAILURE,
                errors: result.errors,
              });
            }

            if (isInitializePurchaseValid && isRefinePurchaseValid) {
              return dispatch(
                handleAddToCart({
                  slug,
                  payload: getAddToCartPayload(store),
                  analytics,
                })
              );
            }
          }
        );
      }
    );
  };



// WEBPACK FOOTER //
// ./src/product/actions/ProductActions.js